import dayjs from 'dayjs';

export const getIOSTime = (seconds: number): string => {
  return dayjs().startOf('day').add(seconds, 'seconds').toISOString();
};
